import { TemplatePublishingStatus } from "components/v2/constants"

export const colorClasses = {
    [TemplatePublishingStatus.INIT]: "bg-amber-500",
    [TemplatePublishingStatus.PUBLISHED]: "bg-emerald-500",
    [TemplatePublishingStatus.DELETED]: "bg-amber-700",
    [TemplatePublishingStatus.ACTIVE]: "bg-amber-700",
    [TemplatePublishingStatus.ARCHIVED]: "bg-amber-700"
}
